<template>
    <div v-show="visible">
        <el-dialog title="新增"  :close-on-click-modal="false" :visible.sync="visible" :before-close="dialogClose"  width="400px">    
            <el-form ref="form" :model="form" :rules="rules" label-width="150px">
                    <el-form-item prop="mentorName" label="导师姓名">
                        <el-button @click="queryMentor()">{{form.mentorNameLabel}}</el-button>
                    </el-form-item> 
                    <el-form-item prop="className" label="导师班名称">
                        <el-input v-model="form.className" maxlength="100" style="width:195px;"></el-input>
                    </el-form-item>
                    <el-form-item prop="studentNameList" label="学生名单">
                        <el-button @click="queryStudent()">{{form.studentNameListLabel}}</el-button>
                    </el-form-item>
                    <el-form-item  label="推送评价通知给导师">
                        <el-checkbox v-model="form.noticeMentor"></el-checkbox>
                    </el-form-item>
                    <el-form-item  prop="orderNum" label="排序号">
                        <el-input v-model="form.orderNum" maxlength="10" type="number" style="width: 70px;"></el-input>
                    </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible=false">取 消</el-button>
                <el-button v-loading="loading" type="primary" @click="save()">确 定</el-button>
            </span>    
        </el-dialog>
        <!-- 人员弹出框 -->
        <div v-if="transferVisible">
            <userTransfer ref="userTransfer"></userTransfer>
        </div>
    </div>
</template>
       
<script>
    import http from '../../../../common/http';
    import userTransfer from '../../sys/user/UserTransfer.vue';

    export default {
        data(){
            return{
                visible: false,
                loading:false,
                isAuto:false,
                transferVisible:false,
                props: { checkStrictly: true},
                form:{
                    id:"",
                    deptId:"",
                    className:"",
                    noticeMentor:true,
                    mentorId:[],
                    mentorName:"",
                    mentorNameLabel:"请选择",
                    studentIdList:[],
                    studentNameList:"",
                    studentNameListLabel:"请选择",
                    orderNum:""
                },
                rules: {
                    className: [
                        { required: true, message: '请输入导师班名称', trigger: 'blur' }
                    ],
                    orderNum: [
                        { required: true, message: '请输入排序号', trigger: 'blur' }
                    ]
                },
                // 人员类型（1-学生，2-教职）
                selectPersonType:1,
            }
        },
        created:function () {
        },
        components: {
            userTransfer
        },
        methods:{
            init(deptId){
                this.visible=true;
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields();
                }

                this.form.deptId=deptId;
                this.form.noticeMentor = true;
                this.form.mentorId=[];
                this.form.mentorName="";
                this.form.mentorNameLabel="请选择";
                this.form.studentIdList=[];
                this.form.studentNameList="";
                this.form.studentNameListLabel="请选择";
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            // 导师姓名
            queryMentor(){
                this.selectPersonType=2;
                this.transferVisible=true;
                this.$nextTick(() => {
                    if(this.$util.isNotEmpty(this.form.mentorId)){
                        this.$refs['userTransfer'].init(2,this.form.mentorId,2,this.form.deptId);
                    }else{
                        this.$refs['userTransfer'].init(2,null,2,this.form.deptId);
                    }
                })
            },
            // 学生名单
            queryStudent(){
                this.selectPersonType=1;
                this.transferVisible=true;
                this.$nextTick(() => {
                    if(this.$util.isNotEmpty(this.form.studentIdList)){
                        this.$refs['userTransfer'].init(1,this.form.studentIdList,2,this.form.deptId);
                    }else{
                        this.$refs['userTransfer'].init(1,null,2,this.form.deptId);
                    }
                })
            },
            setUser(keyArr,nameArr){
                // console.log('选中人员',keyArr);
                // console.log('selectPersonType',(this.selectPersonType))
                if(this.selectPersonType == 2){
                    if(keyArr.length == 0){
                        this.form.mentorId=[];
                        this.form.mentorName=[];
                        this.form.className="";
                        this.form.mentorNameLabel="请选择";
                    }else{ 
                        this.form.mentorId=keyArr;
                        this.form.mentorName = nameArr;

                        this.form.className=nameArr.join(',')+"导师班";
                        this.form.mentorNameLabel=keyArr.length+"人";
                    }
                }else if(this.selectPersonType == 1){
                    if(keyArr.length == 0){
                        this.form.studentIdList=[];
                        this.form.studentNameList=[];
                        this.form.studentNameListLabel="请选择";
                    }else{
                        this.form.studentIdList=keyArr;
                        this.form.studentNameList=nameArr;
                        this.form.studentNameListLabel=keyArr.length+"人";
                    }
                }
            },
            save(){
                this.$refs['form'].validate((valid) => {
                    if(valid){
                        
                        // 导师姓名,不可为空
                        if(this.form.mentorId.length == 0){
                            this.$commonFn.showTip('导师姓名不可为空',3);
                            return;
                        }

                        // 学生姓名,不可为空
                        if(this.form.studentIdList.length == 0){
                            this.$commonFn.showTip('学生名单不可为空',3);
                            return;
                        }

                        let url = this.setMentorClassSaveUrl;
                        let data = {
                            deptId:this.form.deptId,
                            className:this.form.className,
                            mentorId:this.form.mentorId.join(),
                            mentorName:this.form.mentorName.join(),
                            studentIdList:this.form.studentIdList.join(),
                            studentNameList:this.form.studentNameList.join(),
                            noticeMentor: this.form.noticeMentor?1:2,
                            orderNum:this.form.orderNum
                        };
                        // console.log(JSON.stringify(data));
                        // return;
                        this.loading=true;
                        this.apiPost(url, data).then((res) => {
                            if(res.status === 200){
                                this.$commonFn.showTip(res.message,1);
                                this.visible=false;
                                this.$parent.getData();
                            }else{
                                this.$commonFn.showTip(res.message,3);
                            }
                            this.loading=false;
                        }, (err) => {
                            console.log(err);
                            this.$commonFn.showTip(err,3);
                            this.loading=false;
                        });

                    }
                });
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/page/set/setMentorClass/add.vue